import { render, staticRenderFns } from "./InterviewKickstart.vue?vue&type=template&id=01986229"
import script from "./InterviewKickstart.vue?vue&type=script&lang=js"
export * from "./InterviewKickstart.vue?vue&type=script&lang=js"
import style0 from "./InterviewKickstart.vue?vue&type=style&index=0&id=01986229&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports